import { useProcurifyIntl } from '@webapp/hooks'
import { POPDFLabelSetNameForm } from '@webapp/modules/purchasing/components/POPDFLabelSetNameForm'
import { type PDFLabelSet } from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules
import messages from './messages'
import { useRenamePOPDFLabelSetFormPresenter } from './useRenamePOPDFLabelSetFormPresenter'

export interface IRenamePOPDFLabelSetFormPresenterProps {
  /** The set to rename — the Feature Set's active set. */
  labelSet: PDFLabelSet
  /** Closes the FS-owned modal and updates the active set (BHV-038). */
  onSuccess: (set: PDFLabelSet) => void
  onCancel: () => void
}

export const RenamePOPDFLabelSetFormPresenter = ({
  labelSet,
  onSuccess,
  onCancel,
}: IRenamePOPDFLabelSetFormPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    states: { isSaving },
    handlers: { handleSubmit },
  } = useRenamePOPDFLabelSetFormPresenter({ labelSet, onSuccess })

  return (
    <POPDFLabelSetNameForm
      initialName={labelSet.value.name}
      submitButtonText={intl.formatMessage(messages.saveButton)}
      isSaving={isSaving}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  )
}

RenamePOPDFLabelSetFormPresenter.displayName =
  'RenamePOPDFLabelSetFormPresenter'
